import { useState, useRef } from "react";
import Slider from "react-slick";
import "./plan-list-carousel.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import LoadingDots from "../loadingDots";
import BotButton from "../bot-button";
import CategoryGeneric from "../../assets/images/category-generic.svg";
import CarouselPlanItem from "./components/carouselPlanItem";
import CardSimulateAgain from "./components/cardSimulateAgain";
import PlanCard from "./components/planCard";
import { getSliderSettings, shouldBeFullHeight } from "./utils/sliderConfig";
import { usePlanSelection } from "./hooks/usePlanSelection";
import { useCarouselStores } from "./hooks/useCarouselStores";
import { createPlanDetailsHandler } from "./handlers/planDetailsHandler";
import { createButtonHandlers } from "./handlers/buttonHandlers";
import useConsorcioStore from "../../storeModules/useConsorcioStore";
import { tagNovaSimulacao } from "../../utils/sendTag";
import { sendSelectedPlan } from "../../api/requestsFunctions/selectedPlan";

const PlanListCarousel = ({ options }) => {
  const sliderRef = useRef(null);
  let cardRef = useRef(null);

  const [activeSlide, setActiveSlide] = useState(0);

  // Custom hooks para gerenciar estado e stores
  const {
    setMessages,
    setCurrentStep,
    isBotLoading,
    setIsSimulateAgain,
    selectedplano,
    hasDesconto,
    fakeLoad,
  } = useCarouselStores();

  const { selectedPlanID, selectedBemID, updateCheckStatus, isSelectedCard } =
    usePlanSelection(options);

  const setConsorcioStore = useConsorcioStore(
    (state) => state.setConsorcioStore,
  );

  // Handlers
  const handleGetPlanDetails = createPlanDetailsHandler(
    selectedplano,
    setConsorcioStore,
    setMessages,
    setCurrentStep,
    hasDesconto,
    fakeLoad,
  );

  const {
    handleSetButtonText,
    handleClickButton,
    handleSetButtonStyle,
    isButtonEnabled,
  } = createButtonHandlers(
    options,
    activeSlide,
    selectedPlanID,
    isSelectedCard(activeSlide),
    setIsSimulateAgain,
    sliderRef,
    {
      setCurrentStep,
      handleGetPlanDetails,
      tagNovaSimulacao,
      sendSelectedPlan,
    },
  );

  // Configurações do slider com callback
  const settings = {
    ...getSliderSettings(),
    beforeChange: (current, next) => setActiveSlide(next),
  };

  return (
    <div className="carousel-plan-container">
      {options.length && !isBotLoading ? (
        <Slider
          ref={(slider) => {
            sliderRef.current = slider;
          }}
          {...settings}
        >
          {options.map((plan, index) => {
            return (
              <CarouselPlanItem key={`plan-${index}`}>
                {plan.planoCardType === "simular-novamente" ? (
                  <CardSimulateAgain
                    cardRef={cardRef}
                    activeSlide={activeSlide}
                    index={index}
                    options={options}
                    CategoryGeneric={CategoryGeneric}
                    shouldBeFullHeight={shouldBeFullHeight}
                  />
                ) : (
                  <PlanCard
                    activeSlide={activeSlide}
                    index={index}
                    plan={plan}
                    selectedPlanID={selectedPlanID}
                    selectedBemID={selectedBemID}
                    shouldBeFullHeight={shouldBeFullHeight}
                    options={options}
                    updateCheckStatus={updateCheckStatus}
                  />
                )}
              </CarouselPlanItem>
            );
          })}
        </Slider>
      ) : (
        <div className="carousel-loading">
          <LoadingDots size="small" color="primary" />
        </div>
      )}
      <div className="carousel-buttons">
        <BotButton
          variant={handleSetButtonStyle()}
          onClick={handleClickButton}
          text={handleSetButtonText()}
          enabled={isButtonEnabled()}
          className="option-button"
        />
      </div>
    </div>
  );
};

export default PlanListCarousel;
